import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { Client, ComponentActionTypes, TemplateRow, TriggeredComponentAction } from "@interfaces";
import { parseColour } from "src/app/helpers/colour";
import { getGridGap, getGridMaxCols, getMargin, getMobileGridGap, getPadding } from "src/app/helpers/tailwind";
import { SubdomainService } from "src/app/rest/subdomain.service";
import { ComponentActionsService } from "src/app/services/component-actions.service";
@Component({
    selector: "app-template-row",
    templateUrl: "./template-row.component.html",
    styleUrls: ["./template-row.component.css"],
    standalone: true,
    imports: [CommonModule],
})
export class TemplateRowComponent implements OnInit {
    @Input() row: TemplateRow;
    @Input() rowIndex: number;
    @Input() editMode: boolean;
    @Input() isHighlighted = false;
    @Input() mobileMode = false;
    public client: Client;
    public backgroundStyle = {};
    public rowClasses = [];;

    constructor(private actions: ComponentActionsService, private subdomain: SubdomainService) {}

    ngOnInit(): void {
        this.subdomain.getClient().subscribe((client) => {
            this.client = client;
            this.setupAppearance();
        });
        this.actions.componentActionReceived.subscribe((value: TriggeredComponentAction) => {
            switch (value.action) {
                case ComponentActionTypes.COMPONENT_HIGHLIGHTED:
                case ComponentActionTypes.GRID_COMPONENT_HIGHLIGHTED:
                    this.isHighlighted = false;
                    break;
                case ComponentActionTypes.ROW_HIGHLIGHTED:
                    this.isHighlighted = value.rowIndex === this.rowIndex;
                    break;
            }
        });
    }

    onHuskClicked() {
        this.actions.triggerComponentAction({
            action: ComponentActionTypes.ROW_CLICKED,
            componentIndex: null,
            rowIndex: this.rowIndex,
            rowData: this.row,
        });
    }

    public setupAppearance() {
        this.calculateClasses();
        this.backgroundStyle = {
            ...this.calculateBackgroundStyles(),
        };
    }

    private calculateClasses() {
        const classes = [];
        if (!this.row.fullWidth) {
            if(this.row.narrowWidth) {
                classes.push("max-w-[900px] mx-auto");
            } else {
                classes.push("container mx-auto");
            }
        }


        if (this.editMode && !this.isHighlighted) {
            classes.push("border-none");
        } else if (this.editMode && this.isHighlighted) {
            classes.push("border-2", "border-indigo-900");
        }

        if(!this.row.maxCols) {
            classes.push(getGridMaxCols(this.row.components?.length));
        } else if(!this.row.components?.length) {
            classes.push(getGridMaxCols(1));
        } else {
            classes.push(getGridMaxCols(this.row.maxCols));
        }

        classes.push(getGridGap(this.row.gridGap));
        classes.push(getMobileGridGap(this.row.mobileGridGap));
        classes.push(
            getPadding(this.row.paddingTop, "t", true),
            getPadding(this.row.paddingBottom, "b", true),
            getPadding(this.row.paddingLeft, "l", true),
            getPadding(this.row.paddingRight, "r", true),
            getPadding(this.row.mobilePaddingTop, "t", false),
            getPadding(this.row.mobilePaddingBottom, "b", false),
            getPadding(this.row.mobilePaddingLeft, "l", false),
            getPadding(this.row.mobilePaddingRight, "r", false),
            getMargin(this.row.marginTop, "t", true),
            getMargin(this.row.marginBottom, "b", true),
            getMargin(this.row.mobileMarginTop, "t", false),
            getMargin(this.row.mobileMarginBottom, "b", false),
        );
        this.rowClasses = classes;
    }

    private calculateBackgroundStyles() {
        let parsedColor,
            background = "transparent";

        if (this.row?.background?.type === "custom") {
            parsedColor = parseColour(this.row?.background?.value || "#f4f3f3");
            let [r, g, b] = parsedColor.values;
            background = `rgba(${r},${g}, ${b}, 1)`;
        } else if (this.row?.background?.type === "primary") {
            parsedColor = parseColour(this.client.brandColours.primary || "#f4f3f3");
            let [r, g, b] = parsedColor.values;
            background = `rgba(${r},${g}, ${b}, 1)`;
        } else if (this.row?.background?.type === "secondary") {
            parsedColor = parseColour(this.client.brandColours.secondary || "#f4f3f3");
            let [r, g, b] = parsedColor.values;
            background = `rgba(${r},${g}, ${b}, 1)`;
        }

        return { "--background": background };
    }
}
